import type { IncidentListItem } from '@prerender/diagnostics-api';

import { formatRequestCount, MINUS_SIGN } from './crawlerEvidenceFigures';

export type ImpactLines = {
  primary: string;
  secondary?: string;
};

type ImpactOfIncident = Pick<
  IncidentListItem,
  'incidentType' | 'affectedUrlCount' | 'crawledUrlCount' | 'requestImpactCount'
>;

const shareOf = (affected: number, crawled: number): string => {
  const percent = Math.round((affected / crawled) * 100);

  return affected > 0 && percent === 0 ? '<1%' : `${percent}%`;
};

const urlLine = ({ affectedUrlCount, crawledUrlCount }: ImpactOfIncident): string =>
  crawledUrlCount === 0 || affectedUrlCount > crawledUrlCount
    ? `${formatRequestCount(affectedUrlCount)} URLs`
    : `${formatRequestCount(affectedUrlCount)} of ${formatRequestCount(crawledUrlCount)} URLs (${shareOf(
        affectedUrlCount,
        crawledUrlCount
      )})`;

const originBlockingImpact = (incident: ImpactOfIncident): ImpactLines => ({
  primary: urlLine(incident),
  secondary: `${formatRequestCount(incident.requestImpactCount)} blocked requests`,
});

const notFoundRendersImpact = (incident: ImpactOfIncident): ImpactLines => ({
  primary: `${formatRequestCount(incident.requestImpactCount)} 404 renders`,
  secondary: urlLine(incident),
});

const crawlerDropImpact = (incident: ImpactOfIncident): ImpactLines => ({
  primary: `${MINUS_SIGN}${formatRequestCount(incident.requestImpactCount)} requests`,
  secondary: 'a week, against usual',
});

export function impactLines(incident: ImpactOfIncident): ImpactLines {
  switch (incident.incidentType) {
    case 're1':
      return originBlockingImpact(incident);
    case 'po1':
      return notFoundRendersImpact(incident);
    case 'sd1':
      return crawlerDropImpact(incident);
    default:
      return { primary: urlLine(incident) };
  }
}
